import { render, staticRenderFns } from "./AppAvatarsGroup.vue?vue&type=template&id=48f196a6&scoped=true"
import script from "./AppAvatarsGroup.vue?vue&type=script&lang=js"
export * from "./AppAvatarsGroup.vue?vue&type=script&lang=js"
import style0 from "./AppAvatarsGroup.vue?vue&type=style&index=0&id=48f196a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f196a6",
  null
  
)

export default component.exports